import React from "react";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { awards as A } from "../mock";

const Awards = () => {
  return (
    <section id="blog" className="bg-[#0b0b0b] text-white py-24 md:py-32 px-5">
      <div className="max-w-[1100px] mx-auto">
        <Reveal>
          <p className="text-[#8a8a8a] text-sm mb-3">{A.eyebrow}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-cal text-5xl md:text-7xl mb-14">{A.title}</h2>
        </Reveal>

        <div>
          {A.items.map((it, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <a
                href="#blog"
                className="group flex items-center justify-between gap-6 py-7 border-t border-white/10 hover:px-4 transition-all"
              >
                <span className="font-cal text-2xl md:text-3xl w-40 shrink-0 group-hover:text-[#ff4d17] transition-colors">
                  {it.org}
                </span>
                <span className="text-[#b8b8b8] flex-1">{it.award}</span>
                <span className="hidden sm:block text-[#8a8a8a]">{it.project}</span>
                <ArrowUpRight
                  size={22}
                  className="opacity-0 group-hover:opacity-100 group-hover:text-[#ff4d17] transition-all"
                />
              </a>
            </Reveal>
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </section>
  );
};

export default Awards;
